import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './pincodemodal.scss'

// import components
import Modal from '../../components/Modal'

// Actions
import { loginAs, getAuthResources } from '../../../actions/auth'
// utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// elements
import Inline from '../../elements/inline'
import Icon from '../../elements/icon'
import NumPad from '../../elements/numPad'
import PinCode from '../../elements/pinCode'
import { ModalIcons, MainMenuIcons } from '../../elements/icons'

class PinCodeModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      pincode: '',
      translationKey: '17974'
    }
    this.onClick = this.onClick.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  componentDidMount () {
    this.getKeyEvent()
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.handleKeydown)
  }

  getKeyEvent () {
    window.addEventListener('keydown', this.handleKeydown)
  }

  getKeyCode (keyCode) {
    let pincode = ''
    switch (keyCode) {
      case 96:
        pincode = '0'
        break
      case 97:
        pincode = '1'
        break
      case 98:
        pincode = '2'
        break
      case 99:
        pincode = '3'
        break
      case 100:
        pincode = '4'
        break
      case 101:
        pincode = '5'
        break
      case 102:
        pincode = '6'
        break
      case 103:
        pincode = '7'
        break
      case 104:
        pincode = '8'
        break
      case 105:
        pincode = '9'
        break
      case 8:
        pincode = 'delete'
        break
      default:
        break
    }
    return pincode
  }

  handleKeydown (e) {
    let pincode = this.getKeyCode(e.keyCode)
    if (pincode) {
      this.onClick(pincode)
    }
  }

  onLogin (pinCode) {
    this.props.loginAs(this.props.user.UserId, 0, false, false, pinCode).then((res) => {
      let translationKey = res ? '18034' : '17976'
      if (res) {
        this.props.getAuthResources().then((res) => {
          res.data.permissions = res.data.Permissions
          if (typeof this.props.data.type !== 'undefined') {
            switch (this.props.data.type) {
              case 'inspection':
                if (hasSubscriptionPermission(res.data, 10, 30)) {
                  this.props.router.push('/orders/' + this.props.data.id + '/orderinspection')
                } else {
                  this.props.onClose()
                }
                break
              case 'workcard':
                this.props.router.push('/orders/' + this.props.data.id)
                break
            }
          }
        }).finally(() => {
          this.props.onClose()
        })
      }
      this.setState({
        translationKey,
        pincode: ''
      }, () => {
        if (res) { this.props.onClose() }
      })
    }, (err) => {
      this.setState({
        translationKey: err.response.data.DictionaryKey,
        pincode: ''
      })
    })
  }

  getClasse () {
    let key = this.state.translationKey
    let className = 'pincode-label '
    switch (key.toString()) {
      case '18034':  // approved pin
        className += 'success'
        break
      case '17976': // wrong pincode
        className += 'error'
        break
    }
    return className
  }

  pincodeSubmit (val) {
    let pincode = this.state.pincode
    if (val === 'delete') {
      pincode = pincode.substring(0, pincode.length - 1)
    } else {
      pincode += val
    }
    this.setState({
      pincode: pincode
    }, () => {
      if (pincode.length > 3) {
        this.onLogin(pincode)
      }
    })
  }

  onClick (val) {
    this.pincodeSubmit(val)
  }

  render () {
    let { user } = this.props
    return (
      <div className='pincode_modal'>
        <Modal {...this.props} header={translation('57')} overflowHidden={false} icon={ModalIcons.Employees_White}>
          <div className='pincode_modal--content'>
            <Inline block alignChildren={'center'}>
              <Icon size='s' icon={MainMenuIcons.Customers_Black} />
              {user.Name}
            </Inline>
            <div className={this.getClasse()}>{translation(this.state.translationKey)}</div>
            <PinCode pin={this.state.pincode} />
            <NumPad onClick={this.onClick} />
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  loginAs,
  getAuthResources
})(PinCodeModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/PinCodeModal/index.js